import { render } from "./OpenTrips.vue?vue&type=template&id=2094169c"
import script from "./OpenTrips.vue?vue&type=script&lang=js"
export * from "./OpenTrips.vue?vue&type=script&lang=js"

import exportComponent from "/home/joeyd/Documents/Work/Clients/Taxined/Development/TripTrader/triptrader-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__